define([
    "../hereMapsModule"
], function(hereMapsModule) {
    "use strict";
    
    return hereMapsModule.provider("hereMapsConfiguration", function () {

        var config = {
            apiKey: null
        };

        this.$get = [function () {
            return {
                setConfig: function (value) {
                    config.apiKey = value.apiKey;
                },
                getConfig: function () {
                    return config;
                },

                hasApiKey: function () {
                    return !!config.apiKey;
                }
            };
        }];
        
    });
});